var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-empty",style:('padding: '+_vm.padding+'px;')},[_c('div',{staticClass:"el-empty__image"},[(_vm.image)?_c('img',{style:(_vm.imageStyle),attrs:{"src":_vm.image}}):_vm._e()]),_c('div',{staticClass:"el-empty__description"},[_c('p',[_vm._v(_vm._s(_vm.emptyDescription))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }